export default {
  id: 'notifications',
  routes: [
    { path: '/notifications', title: 'Notifications', breadcrumbs: ['Notifications'], view: () => import('./views/notifications.view.js') },
  ],
};
